module.exports = __webpack_public_path__ + "img/Yes-download.9be0c68b.svg";